import "../styles/project.css";
export default function Projects() {
  const projects = [
    ["Address Watcher", "https://address-watcher.vercel.app/", "watcher"],
    ["Eco Rewards", "https://eco-rewards.vercel.app/", "ecoreward"],
    ["Get Linked Website", "https://get-linked-web.vercel.app/", "getlinked"],
    ["Musica", "https://psalmuel01.github.io/musica/", "musica"],
    ["Crappo", "https://psalmuel01.github.io/crappo-challenge/", "crappo"],
    ["Shopping Cart", "https://shopcarty.netlify.app/", "shopcart"],
    ["Web3 Blog", "https://int-blog-nine.vercel.app/", "web3blog"],
    // ["Home Rentals", "https://psalmuel-rentals.netlify.app/", "rentals"],
    // ["Manage Landing Page", "https://psalmuel01.github.io/manage/", "manage"],
  ];

  return (
    <div className="mt-12 md:mx-8 lg:mx-12" id="projects">
      <h1>My Projects</h1>
      <div className="grid gap-8 grid-cols-1 p-8 md:p-0 md:grid-cols-2">
        {projects.map(([title, url, src]) => (
          <div
            className="relative group shadow-md lg:shadow-lg  overflow-hidden"
            key={title}
          >
            <a href={url} target="_blank" rel="noreferrer" className="">
              <img
                src={`./assets/${src}.png`}
                alt={url}
                className="object-cover group-hover:scale-110 trans duration-500"
              />
              <div className="desc bg-[#0D0E10] bg-opacity-0 group-hover:bg-opacity-50 flex absolute top-0 h-full w-full items-center justify-center trans duration-500">
                <p className="p-4 rounded-full bg-white dark:bg-[#0D0E10]  scale-0 transition-all ease-out duration-200 group-hover:scale-75">
                  {title}
                </p>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
